import PropTypes from 'prop-types';
import React, { Component } from 'react';

import CodeSplitComponent from './CodeSplitComponent';

export default resolveComponent => {
  return class CodeSplitComponentWrapper extends Component {
    static propTypes = {
      resolveAsyncProps: PropTypes.func,
    };

    static defaultProps = {
      resolveAsyncProps: () => Promise.resolve({}),
    };

    render() {
      const { resolveAsyncProps, ...syncProps } = this.props;
      return (
        <CodeSplitComponent syncProps={syncProps} resolveAsyncProps={this.resolveAsyncProps} />
      );
    }

    resolveAsyncProps = () =>
      Promise.all([resolveComponent(), this.props.resolveAsyncProps()]).then(
        ([component, otherProps]) => ({ component, ...otherProps })
      );
  };
};
